import Gen4Awards25 from "./gen4Awards25";

export default Gen4Awards25;
